<template>
  <div>
    <div class="invoiceList">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="primary white--text" style="margin-top: 10px">
            <v-flex xs12 md3 sm3>
              <h3 class="title font-weight-light">Multi-Print Invoices</h3>
            </v-flex>      
            <template>
            <v-flex xs12 md2 sm2>
              <v-select
                class="select-firm"
                dense
                :items="firmsByBrand"
                label="Select Firm"
                v-model="selectedFirm"
                clearable
              ></v-select>
            </v-flex>
            <v-spacer/>
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="white-datepicker"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="datepickerFrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo"
                  :nudge-right="40"
                  lazy
                  class="white-datepicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateTo"
                    @input="datepickerTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md2 sm2 style="text-align: center;">  
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        class="warning white--text"
                        v-on="on"
                      >
                        Print
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        @click="print('printInvoice4')">
                        <v-list-tile-title>
                          Simple Print
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="print('printBasicInvoice')">
                        <v-list-tile-title>
                          Basic Print
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="print('printHorizontalInvoice')">
                        <v-list-tile-title>
                          Detailed Print
                        </v-list-tile-title>
                      </v-list-tile>

                    </v-list>
                  </v-menu>               
              </v-flex>
              <v-flex xs12 md1 sm1 style="text-align: end;">
                <router-link to="/Dashboard">
                  <v-btn icon dark>
                    <v-icon>close</v-icon>
                  </v-btn>
                </router-link>
          
              </v-flex>
            </template>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-data-table
        :items="normalData"
        class="elevation transaction-table"
        :pagination.sync="pagination"
        :headers="invoiceHeader"
      >
        <template slot="items" slot-scope="props">
            <tr>
              <td>
              <v-checkbox
              style="margin: 14px 0 -14px 0;"
      v-model="props.item.selectedForPrint"
    ></v-checkbox>
    </td>
    <td
      class="primary--text font-weight-bold"
      v-html="renderDate(props.item.date)"
    ></td>


    <td>
      <b>{{ buyerById(props.item.buyerId).name }}</b>
    </td>
    <td>
      <b>{{ props.item["invoiceId"] }}</b>
    </td>
    <td>
      <b class="success--text font-weight-bold">{{
        props.item["totalAmount"] || 0 | amount
      }}</b>
    </td>
    <td class="nowrap">
      <b class="text-xs-left "> {{ ((props.item.totalAmount - (props.item.totalExtraCharges || 0 | amount) - (props.item.roundOffAmount || 0 | amount)) - getGSTtotal(props.item)) || 0 | amount}}</b></td>
    <td>
      <b>{{ getGSTtotal(props.item) || 0 | amount }}</b>
    </td>
    <td>
      <b>{{ props.item.totalExtraCharges || 0 | amount }}</b>
    </td>
    <td>
      <b>{{ props.item["discountAmount"] || 0 | amount }}</b>
    </td>
    <td>
      <b class="primary--text font-weight-bold">{{
        props.item["paidAmount"] || 0 | amount
      }}</b>
    </td>
    <td>
      <b class="error--text font-weight-bold">{{
        props.item["remainingAmount"] || 0 | amount
      }}</b>
    </td>

    <td>
      <b>{{ props.item["duration"] }}</b>
    </td>
    <td>
      <b>{{ props.item["paymentType"] }}</b>
    </td>
    <td>
      <b>{{ props.item["status"] }}</b>
    </td>
    <!-- <td>
                    <b>{{ item['transactionType']}}</b>
                  </td> -->
    <td>
      <b>{{ props.item["gstType"] }}</b>
    </td>
    <td>
      <b>{{
        (props.item["gstType"] == "IGST" ? getGSTtotal(props.item) || 0 : 0) | amount
      }}</b>
    </td>
    <td>
      <b>{{
        (props.item["gstType"] == "SGST|CGST" ? getGSTtotal(props.item) / 2 || 0 : 0)
          | amount
      }}</b>
    </td>
    <td>
      <b>{{
        (props.item["gstType"] == "SGST|CGST" ? getGSTtotal(props.item) / 2 || 0 : 0)
          | amount
      }}</b>
    </td>
    <td>
      <b>{{
        props.item["GST_Percentage_total"]
          ? props.item["GST_Percentage_total"]["GST_3"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        props.item["GST_Percentage_total"]
          ? props.item["GST_Percentage_total"]["GST_5"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        props.item["GST_Percentage_total"]
          ? props.item["GST_Percentage_total"]["GST_12"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        props.item["GST_Percentage_total"]
          ? props.item["GST_Percentage_total"]["GST_18"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        props.item["GST_Percentage_total"]
          ? props.item["GST_Percentage_total"]["GST_28"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{ props.item["adminEmail"] ? props.item["adminEmail"] : "" }}</b>
    </td>
    <td>
      <b>{{ firmNameById(props.item.firm) }}</b>
    </td>
    <td>
      <b>{{ props.item.voucherType }}</b>
    </td>
  </tr>
        </template>
        <template slot="no-data">No rows to Show</template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToBasicInvoice,convertToBasicInvoiceWithoutGST,
convertToSimpleInvoicePrint,convertToBasicInvoiceHorizontal } from "../../../utils/pdfmake.js";

export default {
  data: () => ({
    invoiceHeader: [
       
        { text: "Print", value: "action" },
         { text: "Date", value: "date", sortable: true },
        // { text: "Invoice - Key", value: "Name" },
        { text: "Buyer Name", value: "Father Name" },
        { text: "Invoice No", value: "invoiceId", sortable: true  },
        { text: "Total Amount", value: "totalCurrentAmount" },
        { text: "Basic Amount", value: "basic amount" },
        { text: "GST", value: "GST" },
        { text: "Extra Charges", value: "Extra Charges" },
        { text: "Discount", value: "discount" },
        { text: "Paid Amount", value: "Tehsil" },
        { text: "Due Amount", value: "District" },
        { text: "Duration (in Days)", value: "abs" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Status", value: "Mobile" },
        // { text: "Transaction Type", sortable: true, value: "paymentType" },
        { text: "GST Type", sortable: true, value: "gstType" },
        { text: "IGST Value", sortable: true, value: "gstType" },
        { text: "SGST Value", sortable: true, value: "gstType" },
        { text: "CGST Value", sortable: true, value: "gstType" },
        { text: "GST (3%)", sortable: true, value: "gstType" },
        { text: "GST (5%)", sortable: true, value: "gstType" },
        { text: "GST (12%)", sortable: true, value: "gstType" },
        { text: "GST (18%)", sortable: true, value: "gstType" },
        { text: "GST (28%)", sortable: true, value: "gstType" },
        { text: "Admin email", sortable: true, value: "gstType" },
        { text: "Firm Name", value: "Village" },
        { text: "Voucher type", value: "totalAmount", sortable: false },
      ],
      invoiceProductListHeader: [
        { text: "Name", value: "Name", class: "font-weight-bold primary--text" },
        { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" },
        { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" },
        { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" },
        { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" },
        { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }
      ],
    pagination: {
      rowsPerPage: 10, // -1 for All",
    },
    normalData:[],
    dateFrom: null,
    dateTo: null,
    datepickerFrom: false,
    selectedFirm : null,
    datepickerTo: false,
    printBuffer : [],
    printBufferFinalLength : 0,
  }),
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject(
      "productById",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    if(this.finYear) {
        this.dateFrom = this.formatDate(this.finYear.start);
        this.dateTo = this.formatDate(this.finYear.end);
    }
    this.invoicesByBrandNormal();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]),
    ...mapGlobalGetters({
      gState: "state",
    }),
    firmsByBrand() {
      return this.firms
      .filter((item) => item["brand"] === this.selectedBrand)
      .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item['.key'];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
      });;
    },
  },
  watch:{
     "selectedFirm": {
      handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },
      deep: true
    },
    "dateTo" : {
       handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
       }
    },
    "dateFrom": {
        handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
       }
    }
  },
  methods: {
    convertToSinglePrint(){
      let temp = this.printBuffer[0];
      this.printBuffer.map((item,index)=>{
        if(index!=0) {
          temp.content.push({text: '',pageBreak: 'after'})
          temp.content = temp.content.concat(item.content)
        }
      })
      console.log(this.printBuffer)
      pdfMake.createPdf(temp).download('Acuify_file');
    },
    invoicesByBrandNormal() {
       let toDate = this.dateTo ?  new Date(this.dateTo).getTime() : null;
        let fromDate = this.dateFrom ? new Date(this.dateFrom).getTime() : null;
      let invoiceHistory = this.invoices.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
           (item.deleted != true) &&
          (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
      );
      this.normalData = invoiceHistory;
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map((item) => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    getFirmName(id) {
      let firm = this.firms.filter((item) => item[".key"] == id)[0];
      if (firm) {
        return firm["name"];
      }
    },
    print(type) {
      this.printBuffer = [];
      this.printBufferFinalLength = this.normalData.filter(item => item.selectedForPrint).length
     this.normalData.map((invoice)=>{
       if(invoice.selectedForPrint) {
         this[type](invoice);
       }
     })
    },
    getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            // if (invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Sale";
            // } 
            // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Receipt";
            // }
            // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Receipt";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Purchase";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Payment";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Payment";
            // }
            if (invoice.isBuyer) {
                return "Sale";
            } else {
                return "Purchase";
            }
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      } else {
        return {
          name: "--",
        };
      }
    },
    async printBasicInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      customer.stateCode =  this.gState.filter(item=>item.state == customer.state)[0].code
      // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
      let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let productObj = {};
       if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
        selectedInvoice.items.map((item)=>{
          productObj[item['productId']] =  this.productById[item['productId']];
        })
      }
      let doc = gstInvoice
        ? await convertToBasicInvoice({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
          })
        : await convertToBasicInvoiceWithoutGST({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            productObj : productObj
          });
      this.printBuffer.push(doc);
      if(this.printBufferFinalLength == this.printBuffer.length) {
         this.convertToSinglePrint();
      }
     
    },
    async printHorizontalInvoice(selectedInvoice){
             let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.stateCode =  this.gState.filter(item=>item.state == customer.state)[0].code
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToBasicInvoiceHorizontal({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0]
          }).then((doc) => {
            this.printBuffer.push(doc);
            if(this.printBufferFinalLength == this.printBuffer.length) {
              this.convertToSinglePrint();
            }
          });
    },
    async printInvoice4(selectedInvoice) {
     let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.stateCode =  this.gState.filter(item=>item.state == customer.state)[0].code
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToSimpleInvoicePrint({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0],
            previousDue : [],
            estimates : []
          }).then((doc) => {
            this.printBuffer.push(doc);
            if(this.printBufferFinalLength == this.printBuffer.length) {
              this.convertToSinglePrint();
            }
          });
    },
    getTermsAndConditions(selectedInvoice) {
      return this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === selectedInvoice.firm
      );
    },
    getAddress(item) {
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map((item) => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },

    firmNameById(id) {
      let firm = this.firms.filter((item) => item[".key"] == id)[0];
      if (firm) {
        return firm["name"];
      }
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    
  },
};
</script>

<style>
.flexColumn {
  flex-direction: column;
  align-items: flex-start;
}
.theme--light .white-switch {
  margin-top: 25px;
}

.theme--light .white-switch .v-label {
  color: white;
}

.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}

.white-datepicker .v-input__slot:before {
  border-color: white !important;
}
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/MultiPrintInvoices/MultiPrintInvoices.vue